import styled from 'styled-components';
import { Input } from './Input.styled';

export const InputWrapper = styled.div`
    position: relative;
    cursor: pointer;

    svg {
        position: absolute;
        top: 20.83px;
        right: 17.6px;
        pointer-events: none;
    }
`;

export const Select = styled.div`
    position: relative;

    ${Input} {
        cursor: pointer;
    }

    svg {
        cursor: pointer;
    }
`;
